import React from "react";
import styled from "styled-components";
import Modal from "../Modal/Modal";
import { Divider } from "rsuite";
import PreviewHeader from "../PreviewHeader/PreviewHeader";
import SeverityHeader from "../SeverityHeader/SeverityHeader";
import SeverityAlert from "../SeverityAlert/SeverityAlert";
import Button from "../Button/Button";

const AlertModal = ({
  children,
  title,
  open,
  onClose,
  onSubmit,
  severity,
  alertPreview,
  currentValue,
  submitDisabled = false,
  loading = false,
  submitText = "Submit",
  cancelText = "Cancel",
  size = "xs",
  ...props
}) => {
  const footerActions = (
    <StyledFooterActions>
      <Button variant="subtle" onClick={onClose} disabled={loading}>
        {cancelText}
      </Button>
      <Button
        variant="primary"
        onClick={onSubmit}
        disabled={submitDisabled || loading}
        loading={loading}
      >
        {submitText}
      </Button>
    </StyledFooterActions>
  );

  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      size={size}
      showFooter={true}
      footerActions={footerActions}
      loading={loading}
      {...props}
    >
      {/* Alert Preview Section */}
      {(severity || alertPreview) && (
        <>
          <Divider style={{ margin: 0 }} />
          {severity && (
            <PreviewHeader>
              <SeverityHeader severity={severity}>
                <b>{severity?.toUpperCase()} SEVERITY ALERT</b>
              </SeverityHeader>
            </PreviewHeader>
          )}

          {alertPreview && (
            <PreviewHeader>
              <b>{alertPreview}</b>
            </PreviewHeader>
          )}

          {currentValue && (
            <StyledCurrentValueSection>
              Current Value: {currentValue}
            </StyledCurrentValueSection>
          )}
        </>
      )}

      <Divider style={{ margin: "16px 0" }} />

      {/* Form Content */}
      <StyledFormContent>{children}</StyledFormContent>
    </Modal>
  );
};

const StyledFooterActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  width: 100%;
`;

const StyledFormContent = styled.div`
  padding-top: 8px;
`;

const StyledCurrentValueSection = styled.div`
  padding: 12px 0;
  text-align: center;
  font-size: 14px;
  color: #666;
`;

export default AlertModal;
